import React from 'react';
import { UHCSliderCompleteProps } from '../SliderAndVcpu';
import { convertPipesToGroupingVcpu, getGroupVcpuSelected } from './Vcpu.service';
import { VcpuBackground, VcpuBackgroundBox, VcpuLabel, VcpuLabelBox, VcpuDiv } from './Vcpu.styled';
import { SliderColorsOptions, getSliderColor } from '@/components/Dumb/Organisms/Slider/sliderColors';


export interface UHC_VcpuProps {
    pipes: UHCSliderCompleteProps['pipes'];
    currentPipe: number,
    color: SliderColorsOptions

}

export interface GroupingVcpu {
    vcpu: number,
    blocos: number
}


const UHC_Vcpu: React.FC<UHC_VcpuProps> = (props: UHC_VcpuProps) => {
    const groupingVcpu: GroupingVcpu[] = convertPipesToGroupingVcpu(props.pipes);
    const groupVcpuSelected = getGroupVcpuSelected(props.currentPipe, props.pipes);        
    
    return (
        <>
            <VcpuLabelBox>
                {groupingVcpu.map((val, index) => {
                    return (
                        <VcpuDiv key={index} current={groupVcpuSelected} groupingVcpu={val} >
                            <VcpuLabel color={getSliderColor(props.color)} key={index} current={groupVcpuSelected} groupingVcpu={val}>{`${val.vcpu} vCPU${val.vcpu != 1?'s':''}`}</VcpuLabel>
                        </VcpuDiv>
                    )
                })}
            </VcpuLabelBox>
            <VcpuBackgroundBox>
                {groupingVcpu.map((val, index) => {
                    return (
                        <VcpuBackground color={getSliderColor(props.color, 'light')} key={index} current={groupVcpuSelected} groupingVcpu={val}></VcpuBackground>
                    )
                })}
            </VcpuBackgroundBox>
        </>
    );
}

export default UHC_Vcpu;